import React from 'react';
import {
    MenuWrapper,
    MenuItem,
} from "./styles";
import { PcMenuConfig } from './MenuConfig';

const Menu = (props) => {
    const {
        activeSection
    } = props;

    return (
        <MenuWrapper>
            {PcMenuConfig.map((each, index) => {
                return (
                    <MenuItem
                        key={index}
                        href={
                            each.sectionName
                                ? each.url + "#" + each.sectionName
                                : each.url
                        }
                        isActive={
                            each.sectionName
                                ? activeSection === each.sectionName
                                : window.location.pathname.includes(each.url)
                        }
                    >
                        {each.title}
                    </MenuItem>
                )
            })}
        </MenuWrapper>
    )
}

export default Menu;